import orders from "./orders"
import packages from "./packages"
import other from "./other"

export default{
    orders,
    packages,
    other
}